// extracted by mini-css-extract-plugin
export default {"container":"Badge_container__V4NdL","icon":"Badge_icon__XBYXK","textContainer":"Badge_textContainer__CKYNc","title":"Badge_title__NokLA","text":"Badge_text__c59Mr"};